import { Address } from './address.model';
import { Title } from './title.enum';

export interface ContractPerson {
  title: Title;
  name: string;
  telephoneNumber: string;
  email: string;
  address: Address;
}
